import { gql } from '@apollo/client';

export const UPDATE_VIRTUAL_HOTEL_USER_PROFILE_MUTATION = gql`
  mutation UpdateVirtualHotelUserProfile($data: updateVirtualHotelUserInput!) {
    updateVirtualHotelUser(input: $data) {
      virtualHotelUser {
        id
        fullName
        profilePicture {
          id
          url
          formats
        }
      }
    }
  }
`;
